<script lang="ts">
	import {
		getGameDate,
		getGameTime,
		siteDateFormat,
		calculateGameEnd
	} from '$lib/helpers/app.documents';
	import { asText } from '@prismicio/client';
	import { PrismicImage } from '@prismicio/svelte';

	const { game, highlight, showtag } = $props();
	const isHome = game.data.home_team.uid == 'cardiff-eagles' ? true : false;
</script>

<article class="game" class:highlight>
	{#if showtag == true}
		<div class="game__latest-next">
			<span>Next Game</span>
		</div>
	{/if}

	<div class="d-flex align-items-center">
		<div class="game__logo--container">
			<PrismicImage
				field={isHome ? game.data.home_team.data.logo : game.data.away_team.data.logo}
				class="game__logo"
				loading="lazy"
				alt={isHome ? game.data.home_team.data.name : game.data.away_team.data.name}
			/>
		</div>

		<div class="game__details">
			<div class="game__arena">{game.data.arena}</div>

			{#if isHome}
				<h3 class="game__opposition"><small>vs</small> {asText(game.data.away_team.data.name)}</h3>
			{:else}
				<h3 class="game__opposition"><span>@</span> {asText(game.data.home_team.data.name)}</h3>
			{/if}

			<div class="game__date">
				<div class="date">{getGameDate(game.data.date_time, siteDateFormat)}</div>
				<div class="time">FO: {getGameTime(game.data.date_time, siteDateFormat)}</div>
				<div class="type">{game.data.type}</div>
			</div>
		</div>
	</div>

	<div class="game__time">
		FO: {getGameTime(game.data.date_time, siteDateFormat)}
	</div>
</article>

{@html `
	<script type="application/ld+json">
		{
			"@context": "https://schema.org",
			"@type": "SportsEvent",
			"name": "${asText(game.data.home_team.data.name)} vs ${asText(game.data.away_team.data.name)}",
			"startDate": "${game.data.date_time}",
			"eventStatus": "https://schema.org/EventScheduled",
			"sport": "Ice Hockey",
			"location": {
				"@type": "Place",
				"name": "${game.data.arena}"
			},
			"homeTeam": {
				"@type": "SportsTeam",
				"name": "${asText(game.data.home_team.data.name)}"
			},
			"awayTeam": {
				"@type": "SportsTeam",
				"name": "${asText(game.data.away_team.data.name)}"
			},
			"organizer": {
				"@type": "Organization",
				"name": "${game.data.type}"
			}
		}
		</script>
`}
